import { BaseEditViewStore} from 'core/stores';
import { FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalForm } from 'application/facility-order-new-flow-us-intake/forms';
import { FacilityOrderPatientService } from "application/facility-order-new-flow-insurance/services";
import { action } from "mobx";

class FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderPatient = componentProps.modalParams.data.facilityOrderPatient;
        super(rootStore, {
            name: 'facility-order-patient-us-intake-edit-eligibility-status-note-modal',
            Form: FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalForm,
            id: facilityOrderPatient.id,
            actions: () => {
                return {
                    get: async() =>{
                        return facilityOrderPatient;
                    },
                    update: async() =>{
                        await this.facilityOrderPatientService.update(this.facilityOrderPatient);
                    }
                }
            },
            FormClass: FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderPatientService = new FacilityOrderPatientService(rootStore.application.baasic.apiClient);
        this.facilityOrderPatient = facilityOrderPatient;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }
            this.facilityOrderPatient.eligibilityStatusNote = this.form.$("eligibilityStatusNote").value;
            this.actions.update();
            await this.modalParams.close();
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('FACILITY_ORDER_NEW_FLOW.EDIT.TEMPLATE_NOTE.SUCCESS_UPDATE', name);
    }
}

export default FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalStore;
